import { Component, OnInit } from '@angular/core';
import { AuthService } from './service/auth.service';
import { ActivatedRoute,Router, NavigationEnd } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Formed';
  tokenData = this.authService.getTokenData();
  routeID;
  
  constructor(private authService: AuthService,
    private router: Router,
    ) { 

    this.router.events.subscribe((val) => {
      if(val instanceof NavigationEnd){

        this.routeID = val.url;
        this.tokenData = this.authService.getTokenData();
      }
    });
  }

  ngOnInit(): void {
    console.log(this.tokenData, 'huhuu');
  }

}
